export default __webpack_public_path__ + "a83ac6e2de7b544e72bc825e3703fe3d.svg";